import { render, staticRenderFns } from "./ProjectViewCompareArea.vue?vue&type=template&id=912eadf2&"
import script from "./ProjectViewCompareArea.vue?vue&type=script&lang=js&"
export * from "./ProjectViewCompareArea.vue?vue&type=script&lang=js&"
import style0 from "./ProjectViewCompareArea.vue?vue&type=style&index=0&id=912eadf2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
